import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  unit, 
  change, 
  changeType, 
  icon, 
  status, 
  sparklineData = [],
  onClick 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'excellent': return 'text-success';
      case 'good': return 'text-primary';
      case 'warning': return 'text-warning';
      case 'critical': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBgColor = () => {
    switch (status) {
      case 'excellent': return 'bg-success/10';
      case 'good': return 'bg-primary/10';
      case 'warning': return 'bg-warning/10';
      case 'critical': return 'bg-error/10';
      default: return 'bg-muted/10';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 hover-lift cursor-pointer nav-transition ${getStatusBgColor()}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`p-2 rounded-lg ${getStatusBgColor()}`}>
          <Icon name={icon} size={24} className={getStatusColor()} />
        </div>
        <div className={`status-indicator ${status === 'excellent' ? 'status-online' : status === 'warning' ? 'status-warning' : status === 'critical' ? 'status-offline' : 'status-online'}`}></div>
      </div>
      <div className="space-y-2">
        <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        <div className="flex items-baseline space-x-2">
          <span className="text-2xl font-bold text-foreground">{value}</span>
          {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
        </div>
        
        {change && (
          <div className="flex items-center space-x-1">
            <Icon name={getChangeIcon()} size={16} className={getChangeColor()} />
            <span className={`text-sm font-medium ${getChangeColor()}`}>
              {change}
            </span>
            <span className="text-xs text-muted-foreground">vs last hour</span>
          </div>
        )}

        {sparklineData?.length > 0 && (
          <div className="mt-3">
            <div className="flex items-end space-x-1 h-8">
              {sparklineData?.map((point, index) => (
                <div
                  key={index}
                  className={`flex-1 rounded-sm ${getStatusColor()?.replace('text-', 'bg-')}`}
                  style={{ height: `${(point / Math.max(...sparklineData)) * 100}%` }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;